import React from 'react'
import { T } from 'components/Translations'
import Icon from 'components/Icon'
import StyledBasicModal from './StyledBasicModal'
import Modal from '../Modal'

export const MessageModal = ({ modalId, data }) => (
  <Modal modalId={modalId} close={{ escape: true, overlay: true, button: true, timeout: 3000 }}>
    <div>
      <h1 className="message">{data.text || data.message}</h1>
    </div>
  </Modal>
)

const BasicModal = Content => ({ modalId, data }) => (
  <Modal modalId={modalId} close={{ escape: true, overlay: true, button: true, timeout: 3000 }}>
    <StyledBasicModal>
      <Content {...data} />
    </StyledBasicModal>
  </Modal>
)

export const FriendModal = BasicModal(data => (
  <>
    <Icon src="icon_friend_add_feedback.svg" alt="" />
    <p className="message">{data.messageText}</p>
  </>
))

export const WinkModal = BasicModal(data => (
  <>
    <Icon src="icon_wink_feedback.svg" alt="" />
    <p className="message">{data.messageText}</p>
  </>
))

export const ProfileUpdateModal = BasicModal(data => (
  <>
    <i className={`fa fa-${data.error ? 'times-circle error' : 'check success'}`}></i>
    <div className="message">{data.error || data.success || <T label="messages/detailsUpdated" />}</div>
  </>
))
